<template>
  <div>
    <div class="intro-y flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-5">{{ $t('dashboard.lendingByAge') }}</h2>
    </div>
    <div class="intro-y box p-5 mt-5">
      <DashboardLendingByPieChart :list="chartData" :height="210" />
      <div class="mt-2 mb-9">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="['flex items-center', { 'mt-4': index > 0 }]"
        >
          <div :class="['w-2 h-2 rounded-full mr-3', item.color]"></div>
          <span class="truncate">{{ item.name }}</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardLendingByPieChart from '@/components/dashboard/DashboardLendingByPieChart';

export default {
  props: {
    report: Object,
  },

  components: {
    DashboardLendingByPieChart,
  },

  data() {
    return {
      list: [
        {
          name: this.$t('dashboard.ageLevel1'),
          value: 0,
          color: 'bg-theme-9',
        },
        {
          name: this.$t('dashboard.ageLevel2'),
          value: 0,
          color: 'bg-theme-1',
        },
        {
          name: this.$t('dashboard.ageLevel3'),
          value: 0,
          color: 'bg-theme-12',
        },
        {
          name: this.$t('dashboard.ageLevel4'),
          value: 0,
          color: 'bg-theme-11',
        },
      ],
    };
  },

  created() {
    this.setValues();
  },

  computed: {
    chartData() {
      return {
        labels: this.list.map(item => item.name),
        data: this.list.map(item => item.value),
      };
    },
  },

  methods: {
    setValues() {
      const loanList = this.report.loan.byAge;
      this.list = this.list.map((item, index) => {
        if (loanList.length > index) {
          return { ...item, value: loanList[index] };
        }
        return item;
      });
    },
  },
};
</script>
